import { useCallback, useEffect, useMemo, useState } from 'react';
import queryString from 'query-string';
import { GlobalState } from '@leverege/ui-redux';
import { Auth } from '@leverege/api-redux';
import { PasswordValidatorFactory } from '@leverege/api-validator';
import { EMPTY_OBJ, ResetPasswordDefaultProps } from '../Constants.js';
import { defaultGetPasswordRequirements } from '../Util.js';
import useObjectKeysMemoize from './useObjectKeysMemoize.js';
export default function useResetPassword(opts) {
  const {
    classNames: pClassNames = EMPTY_OBJ,
    components: pComponents,
    variants: pVariants,
    options: pOptions,
    getPasswordRequirements = defaultGetPasswordRequirements,
    onResetPassword,
    onBackToLogin,
    ...restProps
  } = opts;
  const v = useObjectKeysMemoize(pVariants);
  const variants = useMemo(() => {
    return {
      ...ResetPasswordDefaultProps.variants,
      ...v
    };
  }, [v]);
  const c = useObjectKeysMemoize(pComponents);
  const components = useMemo(() => {
    return {
      ...ResetPasswordDefaultProps.components,
      ...c
    };
  }, [c]);
  const classNames = useObjectKeysMemoize(pClassNames);
  const o = useObjectKeysMemoize(pOptions);
  const options = useMemo(() => {
    return {
      ...ResetPasswordDefaultProps.options,
      ...o
    };
  }, [o]);
  const rest = useObjectKeysMemoize(restProps);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [passwordValidator, setPasswordValidator] = useState();
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    const q = queryString.parse(window.location.search);
    const getSettings = async () => {
      const projectId = window.Molten?.getConfig?.('api/projectId') || q.projectId;
      try {
        const settings = await getPasswordRequirements(projectId);
        setPasswordValidator(PasswordValidatorFactory.create(settings));
      } catch (err) {
        setError(err);
        console.error(err);
      }
    };
    if (!q.token || !q.username) {
      onBackToLogin();
    }
    getSettings();
  }, []);
  const onSubmit = useCallback(({
    password,
    confirm
  }) => {
    setLoading(true);
    const q = queryString.parse(window.location.search);
    const username = q.username;
    const token = q.token;
    const projectId = q.projectId;
    GlobalState.dispatch(Auth.resetPassword(username, password, confirm, token, projectId)).then(res => {
      setSubmitted(true);
      setLoading(false);
    });
  }, []);
  return useMemo(() => {
    return {
      components,
      classNames,
      options,
      variants,
      state: {
        loading,
        error,
        submitted
      },
      onBackToLogin,
      onSubmit,
      passwordValidator,
      ...rest
    };
  }, [classNames, components, error, loading, options, rest, variants, passwordValidator, onBackToLogin, onSubmit, submitted]);
}